export const GAME_VENDORS = {
    river: 'river',
    mascot: 'mascot',
    mascotCasino: 'mascot_casino'
};

export const GAME_VENDORS_RIVER = GAME_VENDORS.river;
export const GAME_VENDORS_MASCOT = GAME_VENDORS.mascot;
export const GAME_VENDORS_MASCOTCASINO = GAME_VENDORS.mascotCasino;
